import { AbstractWSService } from "@/services/socket/ws.service";
import { type WSConnection } from "@/plugins/ws.connection";
import { TripSocketHandler } from "@/services/socket/handler/trip.handler.service";

export class TripService extends AbstractWSService {
  constructor(connection: WSConnection) {
    const tripHandler = new TripSocketHandler();

    super(connection, {
      eventHandler: (data: any) => {
        tripHandler.handleWSData(data);
      },
    });
  }
}
